import {Component, ViewChild} from '@angular/core';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Assignment} from './assignment.model';
import {AssignmentService} from './assignment.service';
import {UIRouter} from '@uirouter/angular';
import {CrudConfig, DatatableViewComponent} from '@ngx-ivengi/crud';
import {FileService} from '../file/file.service';

@Component({
  selector: 'app-assignment-overview',
  templateUrl: './assignment-overview.component.html'
})
export class AssignmentOverviewComponent extends DatatableViewComponent<Assignment> {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  public addRoute: string;
  public editRoute: string;
  public assignmentType: string;
  public optionalActionColumns: boolean = false;
  public typeFilterId = this.crudConfig.getFilterId();
  public nameFilterId = this.crudConfig.getFilterId();
  public statusFilterId = this.crudConfig.getFilterId();

  constructor(
    protected assignmentService: AssignmentService,
    protected router: UIRouter,
    protected crudConfig: CrudConfig,
    protected fileService: FileService
  ) {
    super(assignmentService);

    const matches = this.router.stateService.$current.name.match(/^\w+\.(\w+).*$/);
    this.assignmentType = matches[1] || '';
    this.addRoute = `assignment.${this.assignmentType}.add`;
    this.editRoute = `assignment.${this.assignmentType}.edit`;


    this.requestParams.addSortParam({key: 'date', value: 'desc'});

    this.requestParams.filters.addParam({
      id: this.typeFilterId,
      key: 'type',
      operator: 'eq',
      value: this.assignmentType.toUpperCase()
    }).addParam({
      id: this.statusFilterId,
      key: 'status',
      operator: 'ne',
      value: 'PROCESSED'
    });

    const optionalDataColumnsFor = ['execution', 'maintenance'];
    if(optionalDataColumnsFor.indexOf(this.assignmentType) !== -1) {
      this.optionalActionColumns = true;
    }

    this.fetchData();
  }

  public fetchData(): void {
    this.loading  = true;
    this.assignmentService.getAll(this.requestParams).map((assignments: Assignment[]) => {
      return assignments.map((assignment: Assignment) => {
        if(assignment.fileRecordingId) {
          assignment.setFileRecordingSrc(this.fileService.getLinkById(assignment.fileRecordingId));
        }

        if(assignment.fileWorksheetId) {
          assignment.setFileWorksheetSrc(this.fileService.getLinkById(assignment.fileWorksheetId));
        }
        return assignment;
      });
    }).subscribe(data => {
      this.rows = data;
      this.loading = false;
    });
  }

  public filter(event) {
    this.requestParams
      .addFilterParam({
        id: this.nameFilterId,
        key: 'name',
        operator: 'eq',
        value: event.target.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true'
      });

    super.filter(event);
  }

  public processedFilter(event) {
    const operator = (event.target.checked === true) ? 'eq' : 'ne';

    this.requestParams
      .addFilterParam({
        id: this.statusFilterId,
        key: 'status',
        operator: operator,
        value: 'PROCESSED'
      });

    super.filter(event);
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.assignmentService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }


  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go(this.editRoute, { assignmentId: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment-overview.component.ts